import { UserPageData } from '@maxpreps/apiserviceclients/apiModels';
import {
  IAdSlot,
  IBidBarrelConfig
} from '@maxpreps/shared/functions/utils/adUtils';
import { Action } from 'redux';
import { ISiteHeaderMemberData } from '../models/wf/siteHeaderMemberData';

// Make payload a global action property
export interface IMPAction<T> extends Action<T> {
  payload?: any;
}

export enum AsyncDataState {
  NotLoaded,
  Loading,
  Loaded,
  LoadedWithErrors
}

export interface IMemberNameCookie {
  birthdate: string;
  date: string;
  email: string;
  expiration: string;
  gender: string;
  id: string;
  isAuthenticated: boolean;
  isSignedIn: boolean;
  lastRefresh: string;
  name: string;
  photoUrl: string;
  puid: string;
  role: string;
  zip: string;
}

/************\
    STORES
\************/

export enum PageState {
  /**
   * SSR pre-hydrated
   */
  Prehydrated,
  /**
   * CSR to a new page
   */
  Hydrated,
  /**
   * CSR to a new page
   */
  Transitioning,
  /**
   * State for post-hydration AND post-transition
   */
  Transitioned
}

export interface IBidBarrelStore {
  pageState: PageState;
  isInitialized: boolean;
  bidBarrelData?: IBidBarrelConfig;
  slots: IAdSlot[];
  auctionSlots: IAdSlot[];
  isAutomaticPageAuctionComplete: false;
}

export interface IPrivacyConsentStatus {
  targeting: boolean;
  performance: boolean;
  social: boolean;
  functional: boolean;
}

export interface IUserStore {
  // From MemberName cookie
  memberCookieState: AsyncDataState;
  memberCookie?: IMemberNameCookie;
  // From X-MP-UserToken cookie
  tokenCookieState: AsyncDataState;
  tokenCookie?: string;
  // From API (gateways/react/user-page-data/v1)
  pageDataState: AsyncDataState;
  pageData?: UserPageData;
  // From WF
  siteHeaderMemberDataState: AsyncDataState;
  siteHeaderMemberData?: ISiteHeaderMemberData;
  // Meta state
  errors?: Error[];

  privacyConsentStatus: {
    status: AsyncDataState;
    state: IPrivacyConsentStatus;
  };
}

export interface IGlobalStore {
  bidbarrel: IBidBarrelStore;
  user: IUserStore;
}
